export enum AuthPages {
  signInPage = 'signInPage',
  forgotPasswordPage = 'forgotPasswordPage',
  resetPasswordPage = 'resetPasswordPage',
  newPasswordPage = 'newPasswordPage',
}
